import * as React from 'react';
import {useRef} from 'react';
import classnames from 'classnames';

import { useDeviceStore, selectIsMobile, selectIsTablet } from 'features/ui/store/useDeviceStore';
import { useHeaderFoldout } from 'components/hooks/useHeaderFoldout';
import {getCurrentLocale, getCurrentSite} from 'features/services/utils/env-helper';

import './style.scss';

import {HeaderType, Header} from 'components/organisms/Layout/Header';
import {ContentShortcut} from '@atoms/ContentShortcut';

import {Footer} from "@organisms/Layout/Footer";
import {CrisisBanner} from "@molecules/Banners/CrisisBanner";
import {StickyMainNavigation} from "@organisms/Shell/StickyMainNavigation";


interface Props {
    children: React.ReactNode;
}

export const CareerLayout: React.FunctionComponent<Props> = ({children}) => {
    const isMobile = useDeviceStore(selectIsMobile);
    const isTablet = useDeviceStore(selectIsTablet);
    const {foldoutOpen} = useHeaderFoldout();

    const contentStartRef = useRef<HTMLDivElement>(null);
    const mainClass = classnames(`site-${getCurrentSite()}`, `locale-${getCurrentLocale()}`, "corporate", {
        'mobile': isMobile,
        'tablet': isTablet && isMobile,
        'desktop': !isMobile && !isTablet,
        'career': true,
    });

    return (
        <div id="main-page" className={mainClass}>
            <StickyMainNavigation>
                <ContentShortcut contentRef={contentStartRef} />
                <Header headerType={HeaderType.CORPORATE} />
                {/*process.env.NODE_ENV === 'development' //&& false
                        ? : <CorporateHeader />
                    */}
            </StickyMainNavigation>

            <div className="blur-container" aria-hidden={foldoutOpen}>
                <CrisisBanner />
                <main ref={contentStartRef}>
                    {children}
                </main>
            </div>

            <Footer />
        </div>
    );
};
